import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';

import { makeGetExternalAccountByProvider } from '../selectors/external-accounts';

import { getAccountToken } from '../api/external-accounts-api';

import DropdownElement from './dropdown-element';
import Tooltip from './tooltip';

import IconGDrive from '../icons/icon-gdrive';

class DiscussionUtilGoogleDoc extends PureComponent {
    handleSettingsClick = () => {
        this.props.history.push({
            pathname: `/settings/apps`,
            state: {
                closeUrl: this.props.location.pathname
            }
        });
    }

    handleItemClick = ({ id }) => {
        getAccountToken('google', !this.props.account.team)
            .then(({ token }) => {
                this.props.onItemClick(id, token);
            });
    }

    render() {
        const { t } = this.props;

        if (!this.props.account) {
            return (
                <Tooltip disabled={Boolean(this.props.account)} tooltip="Link your Google account first">
                    <div className="editor-additional-item-inner" onClick={this.handleSettingsClick}>
                        <div className="item-icon">
                            <IconGDrive />
                        </div>

                        <div className="item-body">
                            { t('Google Docs file') }
                        </div>
                    </div>
                </Tooltip>
            )
        }
        return (
            <DropdownElement
                defaultYPosition="top"
                xAlign="left"
                items={[
                    {
                        id: 'document',
                        text: t('googleDocs.Document')
                    },
                    {
                        id: 'spreadsheet',
                        text: t('googleDocs.Spreadsheet')
                    },
                    {
                        id: 'presentation',
                        text: t('googleDocs.Presentation')
                    }
                ]}
                onItemClick={this.handleItemClick}
            >
                <div className="editor-additional-item-inner">
                    <div className="item-icon">
                        <IconGDrive />
                    </div>

                    <div className="item-body">
                        { t('Google Docs file') }
                    </div>
                </div>
            </DropdownElement>
        )
    }
}

const makeMapStateToProps = () => {
    const getExternalAccountTeamByProvider = makeGetExternalAccountByProvider();
    const getExternalAccountUserByProvider = makeGetExternalAccountByProvider();

    return ({ externalAccounts }, ownProps) => {
        const teamAccount = getExternalAccountTeamByProvider(externalAccounts.items, 'google', true);
        const userAccount = getExternalAccountUserByProvider(externalAccounts.items, 'google');

        return {
            account: teamAccount || userAccount
        }
    };
}

export default withRouter(connect(makeMapStateToProps)(withTranslation('apps')(DiscussionUtilGoogleDoc)));
